import { isAxiosResponseOk, genericApiError } from '../../api/api-common';
import apiManager from '../../api/api-manager';
import {  parsePirPlan, parsePirPlanDetails } from '../../api/parsers/pirbox-parsers';
import { UserState } from '../../store';
import { getAPIRequestHeaders } from '../../utils/api-utils';
import { PirBoxRepository } from './pirbox-repository';

const transitionPirBoxRepository: PirBoxRepository = {
  getPirProductSummary: async (thunkApi) => {
    const userState: UserState = thunkApi.getState().data.user;
    const response = await apiManager.pirBoxApi.retrievePirDepositPlan1(
      userState.userCode,
      undefined,
      getAPIRequestHeaders(thunkApi)
     )
    if (!isAxiosResponseOk(response) || response.data.result?.length === 0) {
        return genericApiError();
      } else {
        return response.data.result?.flatMap((pirPlan)=>parsePirPlan(pirPlan));
      }
  },
  getPirProductDetail: async(thunkApi, pirCode) => {
    const userState: UserState = thunkApi.getState().data.user;
    const response = await apiManager.pirBoxApi.retrievePirDepositDetailPositions1(userState.userCode,pirCode,true,getAPIRequestHeaders(thunkApi))
    if (!isAxiosResponseOk(response)) {
        return genericApiError();
      } else {
        return parsePirPlanDetails(response.data.result);
      }
  },
  getPirProductGraphDetails: async (thunkApi, pirCode) => {
    const userState: UserState = thunkApi.getState().data.user;
    const response = await apiManager.pirBoxApi.retrieveYearlyPirIndicatorDepositDetail1(userState.userCode,pirCode,getAPIRequestHeaders(thunkApi))
    if (!isAxiosResponseOk(response)) {
        return genericApiError();
      } else {
        return response.data.result;
      }
  },
};

export default  transitionPirBoxRepository;
